import { PerformanceOverTimeHeader } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTimeHeader';
import { Wrapper } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTime.styles';
import { PerformanceOverTimeContent } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTimeContent';

export const PerformanceOverTime = () => {
  return (
    <Wrapper>
      <PerformanceOverTimeHeader />
      <PerformanceOverTimeContent />
    </Wrapper>
  );
};
